import classNames from 'classnames'
import React from 'react'

import useScrollableAnswers from 'themes/common/hooks/useScrollableAnswers'

import './ScrollableAnswersRow.scss'

interface ScrollableAnswersRowProps {
  children: React.ReactNode
  classNameModifiers?: string[]
  selectedAnswerId?: string | string[]
  selectedClassName?: string
  disabled?: boolean
}

const ScrollableAnswersRow = ({
  children,
  classNameModifiers = [],
  selectedAnswerId,
  selectedClassName,
  disabled,
}: ScrollableAnswersRowProps) => {
  const containerRef = React.useRef<HTMLDivElement>(null)
  const rowRef = React.useRef<HTMLDivElement>(null)
  const { wrapperProps, rowProps } = useScrollableAnswers({
    containerRef,
    rowRef,
    selectedAnswerId,
    selectedClassName,
    disabled,
  })

  const className = classNames(
    'scrollable-answers',
    'scrollable-answers--mobile',
    classNameModifiers.map(modifier => `scrollable-answers--${modifier}`)
  )

  return (
    <div className={className} ref={containerRef}>
      <div className="scrollable-answers__wrapper" {...wrapperProps}>
        <div className="scrollable-answers__row" ref={rowRef} data-testid="row" {...rowProps}>
          {children}
        </div>
      </div>
    </div>
  )
}

export default ScrollableAnswersRow
